import { useEffect } from 'react'
import { CONTROLDText } from 'ui/CONTROLD'

export function useUpdateDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = `${title} | ${CONTROLDText}`
  }, [title])
}
